<template>
  <form-row>
    <input id="agree-to-terms" :checked="value" type="checkbox" name="order-options" @change="$emit('input', !value)">
    <label for="agree-to-terms" style="cursor: default;" v-html="$t('product-detail.form.agree-to-terms.label', { termsLink: termsLink })"/>

    <ul v-if="validation.$error" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
      <li v-if="!validation.required">{{ $t('product-detail.form.agree-to-terms.validation.required') }}</li>
    </ul>
  </form-row>
</template>

<script>
import FormRow from '../components/FormRow'

export default {
  components: {
    FormRow
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    termsLink: {
      type: String,
      default: ''
    },
    validation: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/order-item/AgreeToTerms.vue